import { render, staticRenderFns } from "./ScissorsIcon.vue?vue&type=template&id=6720e684&"
import script from "./ScissorsIcon.vue?vue&type=script&lang=js&"
export * from "./ScissorsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports